import { JSessionIdCookieService } from './../../storage/usuario/jsession-id-cookie.service';
import { AmfAbstractService } from './../amf-abstract.service';
import { Injectable } from "@angular/core";
import { InterceptAmfService } from '../intercept/intercept-amf.service';
import { ServiceConst } from '../../const/shared/service-const';

@Injectable({
  providedIn: 'root'
})
export class ParametroService extends AmfAbstractService {
  constructor(private _jSessionIdCookieService: JSessionIdCookieService, private _interceptAmfService: InterceptAmfService) {
    super(ServiceConst.PARAMETRO)
  }

  get() {
    return this._interceptAmfService.interceptAmf(this._amf, ServiceConst.PARAMETRO, 'Listar', [999999, 0, 100, null], this._jSessionIdCookieService.get())
  }

  save(params) {
    return this._interceptAmfService.interceptAmf(this._amf, ServiceConst.PARAMETRO, 'Save', [params], this._jSessionIdCookieService.get())
  }
}